import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import SearchSiteSelect from '../../components/comman/SiteSearchSelect';
import { useEffect, useState } from 'react';
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { useForm, Controller } from 'react-hook-form';
import { DatePicker } from "rsuite";
import ErrorMessage from '../../components/comman/ErrorMessage';
import { toast } from "react-toastify";
import moment from 'moment';
import MultiSelectDropdown from '../../components/comman/MultiSelectDropdown';

const CreateSubTaskModal = ({ isOpen, toggle, selectedSubTask, getTaskList, refreshSubTask, isCreate = false, setIsCreateSubTask }) => {

    const [pageStates, setPageStates] = useState({
        SiteData: [],
        users: [],
        selectedResponsiblePersons: [],
        selectedAccountablePerson: [],
        meetings: [],
        isLoadingSite: false,
        isLoadingUsers: false,
        isLoadingMeetings: false,
        isLoadingSubmit: false,
        isMeetingSitesConstrained: false,
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
        watch,
        setValue,
    } = useForm({ mode: "onBlur" });

    const taskType = watch("taskType");
    const siteId = watch("siteId");
    const accountablePerson = watch("accountablePerson");

    const resetForm = () => {
        reset();
        setPageStates({
            SiteData: [],
            users: [],
            selectedResponsiblePersons: [],
            selectedAccountablePerson: [],
            meetings: [],
            isLoadingSite: false,
            isLoadingMeetings: false,
            isLoadingSubmit: false,
            isMeetingSitesConstrained: false,
        });
        setIsCreateSubTask(false);
        toggle();
    };

    useEffect(() => {
        register("responsiblePersons");
        register("accountablePerson");
    }, [register]);

    useEffect(() => {
        if (isOpen) {
            if (selectedSubTask) {
                setValue("title", isCreate ? "" : selectedSubTask?.title);
                setValue("description", isCreate ? "" : selectedSubTask?.description);
                setValue("taskType", selectedSubTask?.type);
                setValue("priority", selectedSubTask?.priority);
                setValue("siteId", selectedSubTask?.siteId);

                if (selectedSubTask?.dueDate) {
                    setValue("dueDate", selectedSubTask.dueDate.substring(0, 10));
                }

                if (selectedSubTask?.assignedUsers && !isCreate) {
                    const mappedUsers = selectedSubTask?.assignedUsers?.map((item) => ({
                        value: item?.id,
                        label: item?.name,
                        id: item?.id,
                        name: item?.name,
                    }));
                    setValue("responsiblePersons", mappedUsers);
                    setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: mappedUsers }));
                } else if (selectedSubTask?.assignedToId && !isCreate) {
                    try {
                        const parsedIds = JSON.parse(selectedSubTask.assignedToId);
                        if (Array.isArray(parsedIds)) {
                            const mappedUsers = parsedIds.map(id => ({ value: id, label: selectedSubTask.assignedUsers?.[0]?.name, id: id, name: selectedSubTask.assignedUsers?.[0]?.name }));
                            setValue("responsiblePersons", mappedUsers);
                            setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: mappedUsers }));
                        } else {
                            setValue("responsiblePersons", [{ value: selectedSubTask.assignedToId, label: selectedSubTask.assignedUsers?.[0]?.name, id: selectedSubTask.assignedToId, name: selectedSubTask.assignedUsers?.[0]?.name }]);
                            setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: [{ value: selectedSubTask.assignedToId, label: selectedSubTask.assignedUsers?.[0]?.name, id: selectedSubTask.assignedToId, name: selectedSubTask.assignedUsers?.[0]?.name }] }));
                        }
                    } catch (e) {
                        setValue("responsiblePersons", [{ value: selectedSubTask.assignedToId, label: selectedSubTask.assignedUsers?.[0]?.name, id: selectedSubTask.assignedToId, name: selectedSubTask.assignedUsers?.[0]?.name }]);
                        setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: [{ value: selectedSubTask.assignedToId, label: selectedSubTask.assignedUsers?.[0]?.name, id: selectedSubTask.assignedToId, name: selectedSubTask.assignedUsers?.[0]?.name }] }));
                    }
                } else if (isCreate) {
                    setValue("responsiblePersons", []);
                    setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: [] }));
                }

                if (selectedSubTask?.assignedToId2 && !isCreate) {
                    setValue("accountablePerson", [{ value: selectedSubTask.assignedUsers2?.[0]?.id, label: selectedSubTask.assignedUsers2?.[0]?.name, id: selectedSubTask.assignedUsers2?.[0]?.id, name: selectedSubTask.assignedUsers2?.[0]?.name }]);
                    setPageStates((prev) => ({ ...prev, selectedAccountablePerson: [{ value: selectedSubTask.assignedUsers2?.[0]?.id, label: selectedSubTask.assignedUsers2?.[0]?.name, id: selectedSubTask.assignedUsers2?.[0]?.id, name: selectedSubTask.assignedUsers2?.[0]?.name }] }));
                } else if (isCreate) {
                    setValue("accountablePerson", []);
                    setPageStates((prev) => ({ ...prev, selectedAccountablePerson: [] }));
                }


                GetSiteList();
                if (selectedSubTask.siteId) {
                    GetUsersList("", selectedSubTask.siteId, selectedSubTask.type);
                }

                GetUsersList("", "", selectedSubTask.type);

            } else {
                resetForm();
                setPageStates(prev => ({ ...prev, selectedResponsiblePersons: [], selectedAccountablePerson: [] }));
            }
        }
    }, [isOpen, selectedSubTask]);

    const handleResponsiblePersonsChange = (selectedValues) => {
        setValue("responsiblePersons", selectedValues, { shouldValidate: true });
        setPageStates((prevStates) => ({
            ...prevStates,
            selectedResponsiblePersons: selectedValues,
        }));
    };

    const handleAccountablePersonChange = (selectedValues) => {
        setValue("accountablePerson", selectedValues, { shouldValidate: true });
        setPageStates((prevStates) => ({
            ...prevStates,
            selectedAccountablePerson: selectedValues,
        }));
    };

    const GetSiteList = (search) => {
        setPageStates((prevStates) => ({ ...prevStates, isLoadingSite: true }));
        let options = {
            method: "GET",
        };
        let API = apiUrl.get_site + `?pageNumber=1&pageSize=10&type=O%26M${search ? `&search=${search}` : ""}`;
        callApi(API, options).then((response) => {
            setPageStates((prevStates) => ({ ...prevStates, isLoadingSite: false }));
            if (response?.status === true) {
                const formattedData = response.data?.site.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setPageStates((prevStates) => ({
                    ...prevStates,
                    SiteData: formattedData,
                }));
            } else {
                toast.error(response?.message);
            }
        });
    };

    const GetUsersList = (search, currentSiteId, currentTaskType) => {
        const type = currentTaskType !== undefined ? currentTaskType : taskType;
        if (type === "site" && !currentSiteId) {
            setPageStates((prevStates) => ({
                ...prevStates,
                users: [],
            }));
            return;
        }

        setPageStates((prevStates) => ({ ...prevStates, isLoadingUsers: true }));
        let options = {
            method: "GET",
        };
        let API = apiUrl.get_employee + `?pageNumber=1&pageSize=10&status=current`;
        if (currentSiteId) API += `&type=0&siteId=${currentSiteId}`;
        if (!currentSiteId && type === "office") API += `&type=1`;
        if (search) API += `&search=${search}`;


        if (API.endsWith("&")) API = API.slice(0, -1);
        if (API.endsWith("?")) API = API.slice(0, -1);

        callApi(API, options).then((response) => {
            setPageStates((prevStates) => ({ ...prevStates, isLoadingUsers: false }));
            if (response?.status === true) {
                const formattedData = response?.data?.user?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                    id: item?.id,
                    name: item?.name,
                }));
                setPageStates((prevStates) => ({
                    ...prevStates,
                    users: formattedData,
                }));
            } else {
                toast.error(response?.message);
            }
        });
    };

    const onSubmit = (data) => {

        const responsiblePersonsId = data.responsiblePersons?.map((person) => person.id) || [];
        const accountablePersonId = data.accountablePerson?.map((person) => person.id) || [];
        if (responsiblePersonsId?.length === 0) {
            toast.error("Please select at least one responsible person");
            return;
        }
        if (accountablePersonId?.length === 0) {
            toast.error("Please select accountable person");
            return;
        }

        const submitData = {
            ...(isCreate ? { parentTaskId: selectedSubTask?.id } : {}),
            ...(!isCreate ? { taskId: selectedSubTask.id } : {}),
            "title": data.title,
            "description": data.description,
            "type": data.taskType,
            "priority": data.priority,
            "siteId": data.siteId ? data.siteId : null,
            "assignedToId": responsiblePersonsId && responsiblePersonsId.length > 0 ? JSON.stringify(responsiblePersonsId) : null,
            "assignedToId2": accountablePersonId && accountablePersonId.length > 0 ? accountablePersonId[0] : null,
            "dueDate": data.dueDate,
            "meetingId": null,
        }

        const options = {
            method: isCreate ? "POST" : "PUT",
            data: submitData,
        };
        const API = isCreate ? apiUrl.create_task : apiUrl.update_task;
        setPageStates((prevStates) => ({ ...prevStates, isLoadingSubmit: true }));
        callApi(API, options).then((response) => {
            setPageStates((prevStates) => ({ ...prevStates, isLoadingSubmit: false }));
            if (response?.status === true) {
                toast.success(response.message);
                resetForm();
                toggle();
                getTaskList();
                if (refreshSubTask) refreshSubTask();
            } else {
                toast.error(response.message);
            }
        });

    };

    return (
        <Modal isOpen={isOpen} scrollable toggle={resetForm} centered size="xl" className="border-0 shadow-lg task-modal" contentClassName="border-0 rounded-4">
            <ModalHeader toggle={resetForm} className="border-0 pb-2 pt-3 px-3 bg-light rounded-top-4">
                <div className="d-flex align-items-center gap-3">
                    <div className="bg-white p-2 rounded-circle shadow-sm border d-flex align-items-center justify-content-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#257FFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                    </div>
                    <div>
                        <span className="fs-5 fw-bolder mb-0 text-dark d-block" style={{ letterSpacing: "-0.5px" }}>{isCreate ? "Create Sub Task" : "Update Sub Task"}</span>
                        <span className="text-muted fw-medium" style={{ fontSize: "12px" }}>{isCreate ? "Add a sub task and assign it to users" : "Modify existing sub task details"}</span>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className="p-3 d-flex flex-column" style={{ backgroundColor: '#f8fafc' }}>
                <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column flex-grow-1">
                    <div className="bg-white p-3 rounded-4 shadow-sm border-0 flex-grow-1 mb-3">
                        <div className="mb-3">
                            <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                Task Title <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control px-2 py-1 shadow-sm"
                                placeholder="What needs to be done?"
                                style={{ borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: "13px", backgroundColor: '#f8fafc' }}
                                {...register("title", {
                                    required: "This field is required",
                                })}
                            />
                            <ErrorMessage message={errors.title?.message} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                Description <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control px-2 py-1 shadow-sm"
                                rows="3"
                                placeholder="Additional details..."
                                style={{ borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: "13px", resize: 'vertical', backgroundColor: '#f8fafc' }}
                                {...register("description", {
                                    required: "This field is required",
                                })}
                            ></textarea>
                            <ErrorMessage message={errors.description?.message} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                Task Type <span className="text-danger">*</span>
                            </label>
                            <select
                                className="form-select px-2 py-1 shadow-sm"
                                style={{ borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: "13px", backgroundColor: '#f8fafc' }}
                                {...register("taskType", {
                                    required: "This field is required",
                                    onChange: (e) => {
                                        setValue("responsiblePersons", "");
                                        setValue("accountablePerson", "");
                                        setValue("siteId", "");
                                        setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: [], selectedAccountablePerson: [] }));
                                        if (pageStates?.SiteData?.length === 0) {
                                            GetSiteList();
                                        }
                                        GetUsersList("", e.target.value === "site" ? siteId : "", e.target.value);
                                    }
                                })}
                                disabled
                            >
                                <option value="">Select Task Type</option>
                                <option value="site">Site</option>
                                <option value="office">Office</option>

                            </select>
                            <ErrorMessage message={errors.taskType?.message} />
                        </div>
                        <div className="form-group mb-3">
                            <Controller
                                name="siteId"
                                control={control}
                                rules={{ required: taskType === "site" ? "Site is required" : false }}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <div className="shadow-sm rounded-3">
                                        <SearchSiteSelect
                                            label={<span className="fw-semibold text-dark" style={{ fontSize: "12px" }}>Site</span>}
                                            required={taskType === "site" ? true : false}
                                            value={value}
                                            options={pageStates.SiteData}
                                            onSelect={(opt) => {
                                                onChange(opt?.value);
                                                setValue("responsiblePersons", "");
                                                setValue("accountablePerson", "");
                                                setPageStates((prev) => ({ ...prev, selectedResponsiblePersons: [], selectedAccountablePerson: [] }));
                                                taskType === "site" && GetUsersList("", opt?.value, taskType);
                                            }}
                                            onSearch={(q) => { if (!pageStates.isMeetingSitesConstrained) GetSiteList(q) }}
                                            isLoading={pageStates.isLoadingSite}
                                            placeholder="Search Site"
                                            errors={error?.message}
                                            className={pageStates.isMeetingSitesConstrained ? "" : "ps-5"}
                                            disableSearch={pageStates.isMeetingSitesConstrained}
                                            disabled
                                        />
                                    </div>
                                )}
                            />
                        </div>


                        <div className="row mb-0">
                            <div className="col-12 mb-3">
                                <div className="form-group mb-0">
                                    <label htmlFor="responsiblePersons" className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                        Responsible Persons
                                        <span className="text-danger">*</span>
                                    </label>
                                    <MultiSelectDropdown
                                        options={pageStates?.users.filter(u => {
                                            if (Array.isArray(accountablePerson) && accountablePerson.length > 0) {
                                                return accountablePerson[0].id !== u.id;
                                            }
                                            return true;
                                        }) || []}
                                        isLoading={pageStates.isLoadingUsers}
                                        placeholder='Search & Select Users...'
                                        selectedValues={pageStates?.selectedResponsiblePersons}
                                        onChange={(values) => handleResponsiblePersonsChange(values)}
                                        multiSelect={true}
                                        setPageStates={setPageStates}
                                        search={true}
                                        onSearch={(q) => GetUsersList(q, taskType === "site" ? siteId : "", taskType)}
                                        showSelectAll={false}
                                        showUnSelectAll={false}
                                        emptyMessage="No Users Found"
                                    />
                                    {errors.responsiblePersons && <ErrorMessage message={errors.responsiblePersons?.message} />}
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="form-group mb-0">
                                    <label htmlFor="accountablePerson" className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                        Accountable Person
                                        <span className="text-danger">*</span>
                                    </label>
                                    <MultiSelectDropdown
                                        options={pageStates?.users || []}
                                        isLoading={pageStates.isLoadingUsers}
                                        placeholder='Search & Select Accountable Person...'
                                        selectedValues={pageStates?.selectedAccountablePerson}
                                        onChange={(values) => handleAccountablePersonChange(values)}
                                        multiSelect={false}
                                        setPageStates={setPageStates}
                                        search={true}
                                        onSearch={(q) => GetUsersList(q, taskType === "site" ? siteId : "", taskType)}
                                        showSelectAll={false}
                                        showUnSelectAll={false}
                                        emptyMessage="No Users Found"
                                    />
                                    {errors.accountablePerson && <ErrorMessage message={errors.accountablePerson?.message} />}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                    Priority <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select px-2 py-1 shadow-sm"
                                    style={{ borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: "13px", backgroundColor: '#f8fafc' }}
                                    {...register("priority", {
                                        required: "This field is required",
                                    })}
                                >
                                    <option value="">Select Priority</option>
                                    <option value="high">High</option>
                                    <option value="medium">Medium</option>
                                    <option value="low">Low</option>
                                </select>
                                <ErrorMessage message={errors.priority?.message} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                    Due Date <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="dueDate"
                                    control={control}
                                    rules={{
                                        required: "This field is required",
                                        validate: (value) => {
                                            const checkDate = moment(value).startOf('day');
                                            const today = moment().startOf('day');
                                            if (checkDate.isBefore(today)) {
                                                return "Past dates are not allowed for task due dates";
                                            }
                                            return true;
                                        }
                                    }}
                                    render={({ field }) => (
                                        <DatePicker size="sm"
                                            {...field}
                                            id="dueDate"
                                            format="dd/MM/yyyy"
                                            oneTap
                                            placeholder="dd/mm/yyyy"
                                            style={{ width: "100%" }}
                                            value={field.value ? new Date(field.value) : null}
                                            onChange={(date) => {
                                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                            }}
                                            shouldDisableDate={(date) => date < new Date(moment().startOf('day'))}
                                            container={() => document.querySelector('.task-modal .modal-content') || document.body}
                                            cleanable={false}
                                            placement="auto"
                                            disabled
                                        />
                                    )}
                                />
                                <ErrorMessage message={errors.dueDate?.message} />
                            </div>
                        </div>


                    </div>
                    <div className="border-0 pt-0 pb-0 d-flex justify-content-end gap-3 mt-auto">
                        <button
                            type="button"
                            className="btn btn-light border fw-semibold px-4 py-2 rounded-pill"
                            onClick={resetForm}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary fw-semibold px-4 py-2 rounded-pill shadow-sm"
                            disabled={pageStates.isLoadingSubmit}
                        >
                            {pageStates.isLoadingSubmit ? <Spinner size="sm" /> : isCreate ? "Create Sub Task" : "Update Sub Task"}
                        </button>
                    </div>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default CreateSubTaskModal;
